import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { PurchaseReceiptReport } from './purchase-receipt-report.model';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var PurchaseReceiptReportService = /** @class */ (function () {
    function PurchaseReceiptReportService(http) {
        this.http = http;
        this.purchaseReceiptReportUrl = 'reports/';
    }
    PurchaseReceiptReportService.prototype.getPurchaseReceiptReport = function (reportId) {
        var url = "" + this.purchaseReceiptReportUrl + reportId + "/";
        return this.http.get(url).pipe(map(function (response) { return response ? PurchaseReceiptReport.fromJSON(response) : null; }));
    };
    PurchaseReceiptReportService.prototype.deletePurchaseReceiptReport = function (reportId) {
        var url = "" + this.purchaseReceiptReportUrl + reportId + "/";
        return this.http.delete(url);
    };
    PurchaseReceiptReportService.prototype.downloadPurchaseReceiptPdf = function (reportId) {
        return this.http
            .get("" + this.purchaseReceiptReportUrl + reportId + "/", { headers: { 'Accept': 'application/pdf' }, responseType: 'blob' })
            .subscribe(function (response) {
            var fileName = 'purchase-receipt.pdf';
            if (window.navigator.msSaveOrOpenBlob) { // IE/Edge support (https://stackoverflow.com/questions/24007073/open-links-made-by-createobjecturl-in-ie11)
                var fileData = [response];
                var blobObject = new Blob(fileData);
                window.navigator.msSaveOrOpenBlob(blobObject, fileName);
            }
            else {
                var url = window.URL.createObjectURL(response);
                var anchorElement = document.createElement('a');
                document.body.appendChild(anchorElement);
                anchorElement.setAttribute('style', 'display: none');
                anchorElement.href = url;
                anchorElement.download = fileName;
                anchorElement.click();
                window.URL.revokeObjectURL(url);
                anchorElement.remove();
            }
        });
    };
    PurchaseReceiptReportService.ngInjectableDef = i0.defineInjectable({ factory: function PurchaseReceiptReportService_Factory() { return new PurchaseReceiptReportService(i0.inject(i1.HttpClient)); }, token: PurchaseReceiptReportService, providedIn: "root" });
    return PurchaseReceiptReportService;
}());
export { PurchaseReceiptReportService };
